export const pharmacyConsultationDetailsTranslations = {
    en: {
        personalDetails: "Personal Details",
        healthCamp: "Health Camp",
        tokenNo: "Token No",
        beneficiaryName: "Beneficiary Name",
        campDate: "Camp Date",
        createdBy: "Created By",

        pharmacyConsultation: "Pharmacy Consultation",
        medicine: "Medicine",
        medicineName: "Medicine Name",
        quantity: "Quantity",
        remark: "Remark",
        dosage: "Dosage",
        overallRemark: "Overall Remark",
        noMedicinesAvailable: "No medicines available",

        notAvailable: "N/A",
        none: "None"
    },
    mr: {
        personalDetails: "वैयक्तिक तपशील",
        healthCamp: "आरोग्य शिबिर",
        tokenNo: "टोकन क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        campDate: "शिबिर तारीख",
        createdBy: "तयार केले",

        pharmacyConsultation: "फार्मसी सल्ला",
        medicine: "औषध",
        medicineName: "औषधाचे नाव",
        quantity: "प्रमाण",
        remark: "टिप्पणी",
        dosage: "डोस",
        overallRemark: "एकूण टिप्पणी",
        noMedicinesAvailable: "कोणतीही औषधे उपलब्ध नाहीत",

        notAvailable: "उपलब्ध नाही",
        none: "काहीही नाही"
    }
};
